module.exports = __webpack_public_path__ + "media/img/tech_mobile_2-9ebcd6e5.png";